import { t } from "../../../features/store-language/i18n.ts";

export function agencyRoleLabel(role: string) {
  const labels: Record<string, string> = {
    CompanySalesAgent: t("کارشناس فروش"),
    Manager: t("مدیر نمایندگی"),
    Staff: t("پرسنل نمایندگی"),
  };
  return labels[role] || t("کاربر نمایندگی");
}

